<template>
    <button type="button" @click="mark"
            class="c-button c-button--icon-only c-button--small c-product-line__add"
            :class="[{'c-button--success': localItem.IsSelected}, !localItem.IsSelected ? `c-button--${color}` : '']">
        <svgicon v-if="!localItem.IsSelected" :name="iconSvgName"></svgicon>
        <svgicon v-if="localItem.IsSelected" name="check"></svgicon>
    </button>
</template>

<script>
    export default {
        props: {
            item: {type: Object, required: true},
            color: String,
            name: String,
            iconSvgName: {type: String, default:"added"}
        },
        components: {},
        data() {
            return {
                notified: false,
                localItem: this.item
            }
        },
        methods: {
            mark() {
                if (!this.localItem.IsSelected) {
                    this.localItem.IsSelected = true;
                    this.$emit(`update:item`, this.localItem);
                    this.$emit(`change`, this.localItem.IsSelected);
                } else if (!this.notified) {
                    this.$notify({
                        group: 'global',
                        title: 'This product(group) is already added to the list, you can remove this from the product view.',
                        type: 'info',
                        duration: 4000
                    });

                    this.notified = true;
                }
            }
        },
    }
</script>

<style lang="scss">

    @import "~@/assets/scss/private";

    .c-product-line__add{

    }
</style>



// WEBPACK FOOTER //
// src/components/form/productSearch/widgets/Add.vue